import { UserManager } from 'oidc-client-ts';

//base url https://idp.rsl.org.ls/oauth2/token or node env override


  let userManager;

  function getUserManager() {
    return userManager;
  }

  function setupUserManager(baseUrl: string, newSettings: any) {

    const settings = getSettings(baseUrl);
    userManager = new UserManager({ ...settings, ...newSettings });
  }

  function getSettings(baseUrl: string) {
    return {
      authority: `${baseUrl}/oauth2/token`, // Use baseUrl for OIDC provider's URL
      client_id: 'replaceMe', // Replace with your client ID
      //redirect_uri: 'https://rsl-crm-adminportal.azurewebsites.net/html/signin-callback.html', // Replace with your redirect URI
      redirect_uri: 'https://rsl-crm-adminportal.azurewebsites.net/no-auth/user/signin-callback',
      popup_redirect_uri : 'https://rsl-crm-adminportal.azurewebsites.net/no-auth/user/signin-callback', // Replace with your popup redirect URI
      scope: 'openid profile email', // Replace with the scopes you need
      post_logout_redirect_uri: 'https://rsl-crm-adminportal.azurewebsites.net', // Replace with your post logout redirect URI
      client_secret: 'replaceMe',
      //test: autoLogoffTimeout,
      metadata: {
        issuer: `${baseUrl}/oauth2/token`,
        authorization_endpoint: `${baseUrl}/oauth2/authorize`,
        userinfo_endpoint: `${baseUrl}/oauth2/userinfo`,
        end_session_endpoint: `${baseUrl}/oidc/logout`,
        jwks_uri: `${baseUrl}/oauth2/jwks`,
        token_endpoint: `${baseUrl}/oauth2/token`,
      }
    };
  }

  export { getUserManager, setupUserManager, getSettings };
